import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import useStockStore from '../../store'
import { getDateRangeFromQueryStringOrAppStore } from 'src/components/common/helpers/queryString'

export default async function loader({ request }) {
  const queryParams = getQueryStringParamsFromStringUrl(request.url)

  logger.debug(
    '[loader] About to await AppState being ready in Supplier Statements loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Supplier Statements loader'
  )
  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  const getSupplierStatements = queryParams.supplierId
    ? useStockStore
        .getState()
        .getSupplierStatements(
          startDateTime,
          endDateTime,
          queryParams.supplierId,
          false
        )
    : []

  return defer({
    data: Promise.all([getSupplierStatements])
      .then(() => true)
      .catch((error) => {
        logger.error('Supplier Statements Promise.all error', error)
        return false
      }),
  })
}
